import * as actionTypes from './constants'

const initialState = {
  sfdcProperties: [],
  sfdcMappings: [],
  sfdcMetricMappings: [],
  conversationMetrics: {},
  sfdcTaskFields: [],
  sfdcUsers: [],
  sfdcUserMappings: [],
  sfdcUserMappingsError: null,
  sfdcMappingsErr: null,
  sfdcPatchLoading: false,
  sfdcUserMappingLoading: false,
  sfdcAttributesErr: null,
  sfdcObjectList: [],
  sfdcObjectListErr: null,
  sfdcAccountFieldsList: [],
  sfdcContactFieldsList: [],
  sfdcLeadFieldsList: [],
  sfdcFieldsListErr: null,
  sfdcLeadRoutingSettings: [],
  sfdcLeadRoutingSettingsErr: null,
  enrichment: {},
  sfdcEnrichmentFields: [],
  sfdcEnrichmentFieldsErr: null,
}

const sortedByStatic = mappings => _.sortBy(mappings, mapping => !mapping.static)
const deDupe = arr => Array.from(new Set(arr.map(JSON.stringify))).map(JSON.parse)

const sfdcMappings = function(state = initialState, action) {
  const { enrichment } = state
  switch (action.type) {
    case actionTypes.FETCH_SFDC_USERS_SUCCESS:
      return Object.assign({}, state, { sfdcUserMappingLoading: false, sfdcUsers: deDupe([...state.sfdcUsers, ...action.users]) })

    case actionTypes.PATCH_SFDC_USER_MAPPINGS_SUCCESS:
      return Object.assign({}, state, { sfdcUserMappingPatchLoading: false, sfdcUserMappings: action.mappings })

    case actionTypes.PATCH_SFDC_USER_MAPPINGS_FAILED:
      return Object.assign({}, state, { sfdcUserMappingsError: action.err, sfdcUserMappingPatchLoading: false })

    case actionTypes.FETCH_SFDC_USER_MAPPINGS_SUCCESS:
      return Object.assign({}, state, { 
        sfdcUserMappings: action.mappings,
        sfdcUsers: _.merge(state.sfdcUsers, action.users)
      })

    case actionTypes.PATCH_SFDC_METRIC_MAPPINGS_SUCCESS:
      return Object.assign({}, state, { sfdcPatchMetricsLoading: false, sfdcMetricMappings: action.mappings })

    case actionTypes.PATCH_SFDC_METRIC_MAPPINGS_ERROR:
      return Object.assign({}, state, { sfdcPatchMetricsLoading: false, sfdcPatchMetricsErr: action.err })

    case actionTypes.FETCH_SFDC_METRIC_MAPPINGS_SUCCESS:
      return Object.assign({}, state, { 
        sfdcMetricMappings: action.mappings,
      })
    
    case actionTypes.PATCH_SFDC_METRIC_MAPPINGS_START:
      return Object.assign({}, state, { sfdcPatchMetricsLoading: true })

    case actionTypes.FETCH_SFDC_TASK_ATTRIBUTES_SUCCESS:
      return Object.assign({}, state, { sfdcTaskFields: action.properties })

    case actionTypes.FETCH_SFDC_TASK_ATTRIBUTES_ERROR:
      return Object.assign({}, state, { sfdcAttributesErr: action.err })

    case actionTypes.FETCH_METRICS_LIST_SUCCESS:
      return Object.assign({}, state, { conversationMetrics: action.list })

    case actionTypes.FETCH_METRICS_LIST_ERROR:
      return Object.assign({}, state, { conversationMetrics: action.err })  

    case actionTypes.FETCH_SFDC_ATTRIBUTES_SUCCESS:
      return Object.assign({}, state, { sfdcProperties: action.properties })

    case actionTypes.FETCH_SFDC_ATTRIBUTES_ERROR:
      return Object.assign({}, state, { sfdcAttributesErr: action.err })

    case actionTypes.FETCH_SFDC_MAPPINGS_SUCCESS:
      return Object.assign({}, state, { mappings: action.mappings, 
        useCountryAcronyms: action.useCountryAcronyms, 
        useStateAcronyms: action.useStateAcronyms,
        allowAttributeDefaults: action.allowAttributeDefaults
        })

    case actionTypes.FETCH_SFDC_MAPPINGS_ERROR:
      return Object.assign({}, state, { sfdcMappingsErr: action.err })

    case actionTypes.PATCH_SFDC_MAPPINGS_SUCCESS:
      return Object.assign({}, state, { 

        sfdcMappings: sortedByStatic(action.mappings), 
        sfdcMappingsErr: null, 
        sfdcPatchLoading: false 
      })

    case actionTypes.PATCH_SFDC_MAPPINGS_ERROR:
      return Object.assign({}, state, { sfdcMappingsErr: action.err, sfdcPatchLoading: false })

    case actionTypes.PATCH_SFDC_MAPPINGS_START:
      return Object.assign({}, state, { sfdcPatchLoading: true })

    case actionTypes.FETCH_SFDC_USERS_START:
      return Object.assign({}, state, { sfdcUserMappingLoading: true })

    case actionTypes.FETCH_SFDC_USERS_ERROR:
      return Object.assign({}, state, { sfdcUserMappingLoading: false })

    case actionTypes.FETCH_SFDC_OBJECT_LIST_SUCCESS:
      return Object.assign({}, state, { sfdcObjectList: action.objects })
      
    case actionTypes.FETCH_SFDC_OBJECT_LIST_ERROR:
      return Object.assign({}, state, { sfdcObjectListErr: action.err })

    case actionTypes.FETCH_SFDC_FIELD_LIST_SUCCESS:
      switch (action.fieldType) {
        case actionTypes.SFDC_ACCOUNT_FIELDS:
          return Object.assign({}, state, { sfdcAccountFieldsList: action.fields })
        case actionTypes.SFDC_CONTACT_FIELDS:
          return Object.assign({}, state, { sfdcContactFieldsList: action.fields })
        case actionTypes.SFDC_LEAD_FIELDS:
          return Object.assign({}, state, { sfdcLeadFieldsList: action.fields })
        default:
          return action.fieldType
      }

    case actionTypes.FETCH_SFDC_FIELD_LIST_ERROR:
      return Object.assign({}, state, { sfdcFieldsListErr: [ action.fieldType, action.err ]})

    case actionTypes.FETCH_SFDC_LEAD_ROUTING_SETTINGS_SUCCESS:
      return Object.assign({}, state, { sfdcLeadRoutingSettings: action.settings })
      
    case actionTypes.FETCH_SFDC_LEAD_ROUTING_SETTINGS_ERROR:
      return Object.assign({}, state, { sfdcLeadRoutingSettingsErr: action.err })

    case actionTypes.FETCH_SALESFORCE_ENRICHMENT_STARTED:
      enrichment[action.key] = {
        loading: true,
        error: {},
        data: {},
      }
      return Object.assign({}, state, { enrichment: enrichment })

    case actionTypes.FETCH_SALESFORCE_ENRICHMENT_FAILED:
      enrichment[action.key] = {
        loading: false,
        error: action.err,
        data: {},
      }
      return Object.assign({}, state, { enrichment: enrichment })

    case actionTypes.FETCH_SALESFORCE_ENRICHMENT_SUCCESS:
      enrichment[action.key] = {
        loading: false,
        error: {},
        data: action.data,
      }
      return Object.assign({}, state, { enrichment: enrichment })

    case actionTypes.FETCH_SFDC_ENRICHMENT_FIELDS_SUCCESS:
      return Object.assign({}, state, { sfdcEnrichmentFields: action.fields })

    case actionTypes.FETCH_SFDC_ENRICHMENT_FIELDS_ERROR:
      return Object.assign({}, state, { sfdcEnrichmentFieldsErr: action.err })

    case actionTypes.PATCH_SFDC_ENRICHMENT_FIELDS_SUCCESS:
      return Object.assign({}, state, { sfdcEnrichmentFields: action.fields })

    case actionTypes.PATCH_SFDC_ENRICHMENT_FIELDS_ERROR:
      return Object.assign({}, state, { sfdcEnrichmentFieldsErr: action.err })

    default:
      return state
  }
}

export default sfdcMappings



// WEBPACK FOOTER //
// ./src/scripts/app/modules/sfdc/reducer.js